import React from 'react';
import Nav from "../../components/nav";
import Books from "../../components/book/books";

const ListBook = () => {
    return (
        <div>
            <Nav/>
            <Books/>
        </div>
    );
};

export default ListBook;